// extracted by mini-css-extract-plugin
export var fadeInAnimation = "IconItem-module--fadeInAnimation--dd840";
export var icon = "IconItem-module--icon--443e4";
export var iconImg = "IconItem-module--iconImg--39a8c";
export var link = "IconItem-module--link--51317";
export var noFilter = "IconItem-module--noFilter--fff9a";